import { IStepGeometry } from '@stair-craft/common/util';

import { RISER_BOARD_THICKNESS } from '../../constants';
import { IPlanPoint, clipByHalfPlane, planAdd, planNormalToward } from '../shared-plan-geometry/plan-geometry';

/** A board edge the riser stops at: the wall segment, the step's inside and how far in the riser ends. */
export interface IRiserStop {
    readonly from: IPlanPoint;
    readonly to: IPlanPoint;
    readonly inward: IPlanPoint;
    readonly distance: number;
}

/**
 * The riser of a winder in plan: a board `RISER_BOARD_THICKNESS` deep behind the leading edge
 * (innerBack → outerBack), under its own tread, cut where each side board takes over.
 */
export function winderRiserOutline(corners: NonNullable<IStepGeometry['winderCorners']>, stops: readonly IRiserStop[]): IPlanPoint[] {
    const trailingMid: IPlanPoint = {
        x: (corners.innerFront.x + corners.outerFront.x) / 2,
        z: (corners.innerFront.z + corners.outerFront.z) / 2,
    };
    const into: IPlanPoint = planNormalToward(corners.innerBack, corners.outerBack, trailingMid);
    let outline: IPlanPoint[] = [
        corners.innerBack,
        corners.outerBack,
        planAdd(corners.outerBack, into, RISER_BOARD_THICKNESS),
        planAdd(corners.innerBack, into, RISER_BOARD_THICKNESS),
    ];
    // The riser stays under its own tread: never past the trailing edge (near a U turn's pivot
    // the board behind a steep leading edge would otherwise reach under the next flight).
    const leadingMid: IPlanPoint = {
        x: (corners.innerBack.x + corners.outerBack.x) / 2,
        z: (corners.innerBack.z + corners.outerBack.z) / 2,
    };
    outline = clipByHalfPlane(outline, corners.innerFront, planNormalToward(corners.innerFront, corners.outerFront, leadingMid));
    for (const stop of stops) {
        const normal: IPlanPoint = planNormalToward(stop.from, stop.to, stop.inward);
        outline = clipByHalfPlane(outline, planAdd(stop.from, normal, stop.distance), normal);
    }
    return outline;
}
